// src/components/LocalBusinessLd.jsx
import React from "react";

export const LocalBusinessLd = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "name": "Hípica Campo Grande",
    "url": "https://madridcampogrande.es",
    "image": "https://madridcampogrande.es/og/default.jpg",
    "telephone": "+34 627 80 72 48",
    "email": "miguelangelmartin57@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Carretera de Burgos, km 22,5",
      "addressLocality": "Madrid",
      "addressRegion": "Madrid",
      "addressCountry": "ES"
    },
    "sameAs": ["https://www.instagram.com/hipica_madrid_campogrande"]
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};
